import { useEffect, useState } from "react";
import "./paneles.css";

/**
 * La dirección a la que suscribir el móvil.
 *
 * Antes, para sacarla había que entrar por SSH al servidor con la clave del
 * root y buscar una línea en el `.env`. Para algo que se hace desde el
 * teléfono, y una sola vez, eso es demasiada ceremonia — y de paso obliga a
 * andar con la clave del servidor a mano.
 */
export function Calendario() {
  const [url, setUrl] = useState<string | null>(null);
  const [motivo, setMotivo] = useState<string | null>(null);
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    void (async () => {
      const r = await fetch("/api/calendario/enlace", { credentials: "same-origin" });
      if (!r.ok) {
        setMotivo("No se pudo consultar la dirección del calendario.");
        return;
      }
      const datos = (await r.json()) as { url: string | null; motivo?: string };
      setUrl(datos.url);
      if (datos.motivo) setMotivo(datos.motivo);
    })();
  }, []);

  async function copiar() {
    if (!url) return;
    await navigator.clipboard.writeText(url);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2500);
  }

  if (!url)
    return (
      <div className="pnl">
        <p className="pnl-sub">{motivo ?? "Cargando…"}</p>
      </div>
    );

  return (
    <div className="pnl">
      <header className="pnl-cabecera">
        <div>
          <h1>Calendario</h1>
          <p className="pnl-sub">
            Las renovaciones de los clientes, solas en el calendario de tu móvil. Cuando cambia una fecha, cambia ahí.
          </p>
        </div>
      </header>

      <section className="pnl-seccion">
        <header>
          <h2>Tu dirección de suscripción</h2>
        </header>
        <div className="cal-enlace">
          <code>{url}</code>
          <button className="pnl-boton si" onClick={() => void copiar()}>
            {copiado ? "Copiada" : "Copiar"}
          </button>
        </div>
        <p className="cal-aviso">
          Lleva una llave dentro: quien la tenga puede ver tus renovaciones —nombres de clientes e importes— sin
          contraseña. Es como funcionan todos los calendarios suscritos. No la pegues en un sitio compartido. Lo que{" "}
          <strong>no</strong> puede hacer nadie con ella es escribir en tu calendario ni leer tus reuniones.
        </p>
      </section>

      <section className="pnl-seccion">
        <header>
          <h2>Cómo suscribirse</h2>
        </header>
        <div className="cal-pasos">
          <div>
            <h3>iPhone</h3>
            <p>
              Ajustes › Aplicaciones › Calendario › Cuentas › Añadir cuenta › Otra › Añadir suscripción de calendario,
              y pega la dirección.
            </p>
          </div>
          <div>
            <h3>Android / Google Calendar</h3>
            <p>
              Desde un ordenador, en calendar.google.com: Otros calendarios › + › Desde URL. Tarda un rato en aparecer
              en el móvil la primera vez.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
